module.exports = "../fonts/checkbox_selected.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checkbox_selected.svg
// module id = 323
// module chunks = 0